import React, { useEffect, useState, Component } from "react";
import {
  TopToolbar,
  RefreshButton,
  ReferenceField,
  useRedirect,
  TextField,
  SelectInput,
  DateField,
  ListButton,
  ShowButton,
  Edit,
  Create,
  SimpleForm,
  TextInput,
  NumberInput,
  Toolbar,
  SaveButton,
  useTranslate,
} from "react-admin";
import {
  RichTextInput,
  DefaultEditorOptions,
  RichTextInputToolbar,
  LevelSelect,
  FormatButtons,
  AlignmentButtons,
  ListButtons,
  LinkButtons,
  QuoteButtons,
  ClearButtons,
  DirectionButtons,
} from "ra-input-rich-text";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import Dialog from "@mui/material/Dialog";
import {
  GetCurrentUserRoles,
  getLocalStorageKey,
  RUN_TIME_API_ENDPOINT,
  CommonHeaderOption,
} from "../common/common";
import { set } from "express/lib/application";

// const topToolbarStyle = {
//     zIndex: 2,
//     display: 'inline-block',
//     float: 'right',
// };

const EditActions = () => (
  <TopToolbar>
    {" "}
    {/* <RefreshButton /> */}{" "}
    <ListButton resource="/terms_and_condition_list" />
  </TopToolbar>
);

const EditTitle = ({ record }) => {
  const translate = useTranslate();

  return (
    <span>
      {" "}
      {translate(
        "resources.terms_and_condition_list.fields.terms_condition"
      )}{" "}
    </span>
  );
};

const TermsConditionEdit = (props) => {
  let navigate = useNavigate();
  const translate = useTranslate();

  const term_and_conditionsdata = getLocalStorageKey("term_condition_data");

  const [toolbarOptions, setToolbarOptions] = useState([
    ["bold", "italic", "underline", "strike"], // toggled buttons
    [{ header: 1 }, { header: 2 }], // custom button values
    [{ list: "ordered" }, { list: "bullet" }],
    [{ direction: "rtl" }], // text direction
    [{ align: [] }],
    // ['blockquote', 'code-block'],
    // [{ 'script': 'sub'}, { 'script': 'super' }],      // superscript/subscript
    // [{ 'indent': '-1'}, { 'indent': '+1' }],          // outdent/indent
    // [{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
    // [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
    // [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
    // [{ 'font': [] }],
    // ['clean']   // remove formatting button
  ]);
  const [termConditionId, setTermConditionId] = useState("");
  // const [term_and_conditionsdata, setTerm_and_conditionsdata] = useState();
  const [language_id, setLanguage_id] = useState(0);
  const [descriptionVal, setDescriptionVal] = useState({});
  const [description, setDescription] = useState("");

  const validateTcEdit = (values) => {
    const errors = {};
    if (!values.description) {
      errors.description = ["The description is required"];
    }
    return errors;
  };

  console.log("term_and_conditionsdata", term_and_conditionsdata);

  useEffect(() => {
    if (term_and_conditionsdata) {
      console.log("inside if called");
      if (term_and_conditionsdata && term_and_conditionsdata.length > 0) {
        // const { match: { params } } = props;
        // console.log(params)

        //  const path=this.props.location.pathName
        let language_id = "";
        let patharray = window.location.href.split("/");
        if (patharray && patharray.length > 0) {
          language_id = patharray[patharray.length - 2];
        }

        let termsConditionId = window.location.href.split("/").pop();
        console.log("termsConditionId", termsConditionId);
        setLanguage_id(language_id);
        setTermConditionId(termsConditionId);
        // this.setState({ language_id: language_id, termConditionId: termsConditionId }, () => {
        //   this.gettermsConditions()
        // })
      }
    }
  }, []);

  useEffect(() => {
    if (language_id || termConditionId) {
      gettermsConditions();
    }
  }, [language_id, termConditionId]);

  // const [terms_and_conditionsdata , setTermsandConditionsdata]=useState({});
  // let [descriptionVal,setDescription]=useState('<p>hello</p>');

  const gettermsConditions = () => {
    const options = CommonHeaderOption();
    const apiUrl = RUN_TIME_API_ENDPOINT;
    options.method = "GET";
    fetch(
      `${apiUrl}/term_and_conditions/${termConditionId}?language_id=${language_id}`,
      options
    )
      .then((res) => {
        return res.json();
      })
      .then((jsonD) => {
        console.log("jsonD ===>", jsonD);
        let obj = {};
        obj.terms_and_conditionsdata = jsonD.data;
        if (jsonD?.data?.description) {
          setDescriptionVal(jsonD.data);
          setDescription(jsonD.data.app_tnc);
        } else {
          setDescriptionVal({});
          setDescription("");
        }
      });
  };

  console.log("description", description);

  const handleChange = (e) => {
    console.log(e.target.value);
    setLanguage_id(e.target.value);
    setDescriptionVal({});
    // this.setState({ language_id: e.target.value, descriptionVal: {} }, () => {
    //   this.gettermsConditions();
    // });
  };

  const handleFormSubmit = () => {
    //   alert('submit');
    const options = CommonHeaderOption();
    const apiUrl = RUN_TIME_API_ENDPOINT;
    let req = {
      description: description,
      language_id: language_id,
    };
    console.log("req", req);
    options.method = "PATCH";
    options.body = JSON.stringify(req);
    fetch(`${apiUrl}/term_and_conditions/${termConditionId}`, options)
      .then((res) => {
        return res.json();
      })
      .then((jsonD) => {
        console.log("jsonD ===>", jsonD);
        navigate("/terms_and_condition_list");
      });
  };

  const checkChange = (e) => {
    //   alert(123)
    console.log("rich text>>>", e);
    setDescription(e);
  };

  console.log("props...//", props);
  const EditToolbar = (props) => (
    <Toolbar {...props}>
      {" "}
      {/* <SaveButton submitOnEnter={false} onClick={props.submitfun}/> */}{" "}
      <div className="so-save-button">
        <button onClick={props.submitfun} disabled={!props.description}>
          {" "}
          {translate("resources.terms_and_condition_list.fields.save")}{" "}
        </button>
      </div>
    </Toolbar>
  );

  return (
    <Create actions={<EditActions />} {...props} title={<EditTitle />}>
      <SimpleForm
        toolbar={
          <EditToolbar submitfun={handleFormSubmit} description={description} />
        }
        redirect="edit"
        validate={validateTcEdit}
      >
        <div className="tnc-instruction">
          <p>
            {" "}
            {translate(
              "resources.terms_and_condition_list.fields.instruction"
            )}{" "}
          </p>{" "}
          <p>
            {" "}
            {translate(
              "resources.terms_and_condition_list.fields.instruction_desc"
            )}{" "}
          </p>{" "}
        </div>{" "}
        {/* <div className="so-input">
                              <label>Select Language<sup>*</sup></label>
                              <select className="inapp-notification-sendto" onChange={this.handleChange}>
                                  {(term_and_conditionsdata && term_and_conditionsdata.length>0) && term_and_conditionsdata.map(item=><option key={item.id} value={item.id}>{item.display_name}</option>) }

                              </select>
                            </div> */}{" "}
        {description && (
          // <RichTextInput initialValue={descriptionVal?.description} source="description" label="Description" onChange={checkChange}
          // toolbar={[
          //   ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
          //   [{ 'direction': 'rtl' }],                         // text direction
          //   [{ 'align': [] }]
          // ]}
          // // toolbar={
          // //   <RichTextInputToolbar>
          // //   <FormatButtons size={'20'} />
          // //   <LinkButtons size={'20'} />
          // //   </RichTextInputToolbar>
          // // }
          // />
          <RichTextInput
            defaultValue={description}
            source="description"
            label="Description"
            onChange={checkChange}
            className="descrpt-cont"
            toolbar={
              <RichTextInputToolbar>
                <FormatButtons />
                <AlignmentButtons />
                <ListButtons />{" "}
                {/* <LinkButtons />
                                      <QuoteButtons />
                                      <ClearButtons /> */}
              </RichTextInputToolbar>
            }
          />
        )}{" "}
      </SimpleForm>
    </Create>
  );
};

export default TermsConditionEdit;
